import React from "react";
import { Box } from "@material-ui/core";
import DocumentUploadField from "../../../../../components/DocumentUploadField";
import { TitleContainer, BorderedBox } from "./style";

const LetterOfIntentUpload = ({ documents, setDocuments, renderDeadline }) => {
  const removeFile = (file) => {
    setDocuments([]);
  };

  const addFiles = (newDocuments) => {
    setDocuments(newDocuments);
  };

  return (
    <div>
      <TitleContainer>Upload award of contract</TitleContainer>
      <BorderedBox>
        <DocumentUploadField addFiles={addFiles} removeFile={removeFile} files={documents} multiple={false} />
      </BorderedBox>
      <Box mt={2} mb={4}>
      {renderDeadline()}
      </Box>
    </div>
  );
};

export default LetterOfIntentUpload;
